import axiosInstance from "@/api/axiosInstance";

export async function reinstateEnrollment(
  enrollmentId: number,
): Promise<void> {
  await axiosInstance.post(
    `/api/private/enrollments/${enrollmentId}/reinstate`,
  );
}
